import z from "zod";

/** Shown under password inputs (sign-up, reset, change password). */
export const PASSWORD_REQUIREMENTS_HELP_TEXT =
  "At least 8 characters, one uppercase letter, and one special character.";

/** Shared rules for new passwords across auth and profile settings. */
export const newPasswordZodField = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .max(50)
  .regex(/[A-Z]/, "Password must contain at least one uppercase letter")
  .regex(
    /[!@#$%^&*(),.?":{}|<>]/,
    "Password must contain at least one special character",
  );
